import React, { useState, useRef } from "react";
import AvatarEditor from "react-avatar-editor";
import { Avatar, Button, Grid, Stack, Slider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheckCircle, faCircleArrowRight, faTimesCircle, faUpload } from "@fortawesome/free-solid-svg-icons";

import { storage } from "../firebase"; // Import Firebase storage instance
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import defaultAvatar from "../assets/img/defaultAvatar.png";

const AvatarEditorWrap = (props) => {
  const [scale, setScale] = useState(1.0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState("");
  const editorRef = useRef(null);

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      props.setIsNewPhoto(true);
    }
  };

  // Handle saving and uploading the image
  const saveAndUpload = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();
      canvas.toBlob(async (blob) => {
        if (blob) {
          const storageRef = ref(storage, `avatars/${Date.now()}.png`);
          try {
            // Upload Blob to Firebase
            await uploadBytes(storageRef, blob);
            const downloadUrl = await getDownloadURL(storageRef);
            props.setPhotoURL(downloadUrl);
            props.setIsNewPhoto(false)
            //alert("Image uploaded successfully!");
          } catch (error) {
            console.error("Upload failed:", error);
            // todo: snackbar on error
          }
        }
      });
    }
  };

  return (
    <Grid container justifyContent={"center"} alignItems={"center"}>
      <Grid item>
        {props.isNewPhoto ? (
          <AvatarEditor
            ref={editorRef}
            image={selectedFile || defaultAvatar}
            width={100}
            height={100}
            border={50}
            borderRadius={50}
            color={[255, 255, 255, 0.7]} // RGBA
            scale={scale}
            rotate={0}
          />
        ) : (
          <Avatar
            src={uploadedUrl || props.photoURL || defaultAvatar}
            sx={{ width: "120px", height: "120px" }}
          />
        )}
      </Grid>
      <Grid item sx={{my: 2}}>
        {props.isNewPhoto ? (
          <>
            <Stack spacing={2} direction="row" sx={{ alignItems: "center", mb: 1, mt: 1 }}>
              <Slider
                aria-label="Scale"
                min={1}
                max={1.8}
                step={0.2}
                value={scale}
                onChange={(e, newVal) => setScale(newVal)}
              />
            </Stack>
            <Button onClick={() => props.setIsNewPhoto(false)} sx={{mt:2}}>
              <FontAwesomeIcon icon={faTimesCircle} />&nbsp;&nbsp;Clear
            </Button>&nbsp;&nbsp;
            <Button variant="contained" onClick={saveAndUpload} sx={{ mt: 2 }}>
                Next&nbsp;&nbsp;<FontAwesomeIcon icon={faCircleArrowRight} />
            </Button>
          </>
        ) : (
          <>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="upload-photo"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="upload-photo">
              <Button variant="outlined" component="span" sx={{ ml: "20px" }}>
                <FontAwesomeIcon icon={faUpload} />
                &nbsp;&nbsp;Upload {props.variant === "user" ? "photo" : "image"}
              </Button>
            </label>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default AvatarEditorWrap;